import { createStore } from 'vuex';

import rootMutations from './rootMutations';
import rootActions from './rootActions';
import rootGetters from './rootGetters';

import murderDataModule from './modules/murderData/index.js';
import crimeDataModule from './modules/crimeData/index.js';


export default createStore({
  state(){
    return {
      isMurdersView : true,
    }
  },
  mutations: rootMutations,
  actions: rootActions,
  getters: rootGetters,
  modules: {
    murder : murderDataModule,
    crime : crimeDataModule,
  }
})
